import EditIcon from '@mui/icons-material/Edit'
import SaveAlt from '@mui/icons-material/SaveAlt'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, ButtonProps } from '../inputs'

export type ActionButtonProps = Omit<ButtonProps, 'href'> & { suffix?: React.ReactNode }
export const EditButton = ({ suffix, ...props }: ActionButtonProps) => (
  <Button color="primary" startIcon={<EditIcon />} size="small" variant="outlined" {...props}>
    <FormattedMessage id="common.edit" />
    {suffix && <> {suffix}</>}
  </Button>
)

export const SubmitButton = ({ suffix, children, ...props }: ActionButtonProps) => (
  <Button
    loadingPosition="start"
    startIcon={<SaveAlt />}
    variant="contained"
    type="submit"
    size="small"
    {...props}
  >
    {children || <FormattedMessage id="common.save" />}
    {suffix && <> {suffix}</>}
  </Button>
)

export const CancelButton = (props: ButtonProps) => (
  <Button color="secondary" variant="text" size="small" {...props}>
    <FormattedMessage id="common.cancel.cancel" />
  </Button>
)
